import React from 'react'
import './Button.css'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    /** Style variant of the button */
    variant?: 'primary' | 'secondary' | 'danger' | 'warning' | 'info' | 'success' | 'ghost' | 'link'
    /** Size variant of the button */
    size?: 'sm' | 'md' | 'lg' | 'xl'
    /** Content of the button, can include text and/or icons */
    children: React.ReactNode
    /** Enable 3D effect with solid shadow */
    effect3d?: boolean
}

/**
 * Button component that follows the design system.
 * Can include an optional icon as a child element.
 */
const Button = ({
    variant = 'primary',
    size = 'md',
    children,
    className = '',
    effect3d = true,
    ...props
}: ButtonProps) => {
    // Ghost and link buttons should never have 3D effect
    const shouldHave3D = effect3d && variant !== 'ghost' && variant !== 'link'
    const effect3dClass = shouldHave3D ? 'domber-btn--3d' : ''
    
    return (
        <button 
            className={`domber-btn domber-btn--${variant} domber-btn--${size} ${effect3dClass} ${className}`}
            {...props}
        >
            {children}
        </button>
    )
}

export default Button
